if (sessionStorage.getItem('logicTwo')) {
    var logic = sessionStorage.getItem('logicTwo')
    logic = JSON.parse(logic)
} else {
    var logic = {
        program: [
            {
                type: 'start',
                state: {
                    bic1: false,
                    bic2: false,
                    bic3: false,
                    bid1: false,
                    bid2: false,
                    bif1: false,
                    bif2: false,
                    bif3: false,
                    bidata1: false,
                    bidata2: false,
                    asgn1: false,
                    asgn2: false,
                    asgn3: false,
                    asgn4: false,
                    asgn5: false,
                },
                bic1: false,
                bic2: false,
                bic3: false,
                bid1: false,
                bid2: false,
                bif1: false,
                bif2: false,
                bif3: false,
                bid3: false,
                bmp3: false,
                bidata1: false,
                bidata2: false,
                asgn1: false,
                asgn2: false,
                asgn3: false,
                asgn4: false,
                asgn5: false,
            },
        ],
        end: { type: 'end', state: 'repeat' },
        insertState: false,
        offset: { left: 0, top: 0 },
        scale: 1,
        currentProgramGuide: 0,
        active: [-1, -1],
        bottomPanel: 'border',
        CUSTOMGROUPACTIONS12: {},
    }
}

const logicSelectionTwo = (state = logic, action) => {
    var { payload } = action

    switch (action.type) {
        case 'LOGIC_SELECTION_TWO':
            var {
                program, end, insertState, offset, scale,
                currentProgramGuide, active, bottomPanel, CUSTOMGROUPACTIONS12,
            } = payload

            var data = {
                ...state,
                program, end, insertState, offset, scale,
                currentProgramGuide, active, bottomPanel, CUSTOMGROUPACTIONS12,
            }
            
            // Change 3: Save to 'logicTwo'
            sessionStorage.setItem('logicTwo', JSON.stringify(data))
            
            if (payload.active[0] !== -1 || payload.active[1] !== -1) {
                sessionStorage.setItem('isSave', JSON.stringify(false))
            }

            return data

        case 'LOGIC_RESET_TWO':
            var {
                program, end, insertState, offset, scale,
                currentProgramGuide, active, bottomPanel,
            } = payload
            var data = {
                ...state,
                program, end, insertState, offset, scale,
                currentProgramGuide, active, bottomPanel,
            }
            sessionStorage.setItem('logicTwo', JSON.stringify(data))
            return data

        default:
            sessionStorage.setItem('logicTwo', JSON.stringify(state))
            return state
    }
}

export default logicSelectionTwo